export const PURCHASE_ORDER_LIST = 'PURCHASE_ORDER_LIST';
export const PURCHASE_ORDER_ERROR = 'PURCHASE_ORDER_ERROR';
export const PURCHASE_ORDER_UPDATE_ITEMS_DATA =
  'PURCHASE_ORDER_UPDATE_ITEMS_DATA';
export const PURCHASE_ORDER_CHECKALL_ITEMS_DATA =
  'PURCHASE_ORDER_CHECKALL_ITEMS_DATA';
export const PURCHASE_ORDER_LOADING = 'PURCHASE_ORDER_LOADING';
export const PURCHASE_ORDER_LOADING_ONCLOSE = 'PURCHASE_ORDER_LOADING_ONCLOSE';
export const PURCHASE_ORDER_PRINT_ERROR = 'PURCHASE_ORDER_PRINT_ERROR';
export const PURCHASE_ORDER_PRINT_LOADING = 'PURCHASE_ORDER_PRINT_LOADING';
export const CLEAR_PURCHASE_ORDER_ERROR = 'CLEAR_PURCHASE_ORDER_ERROR';
export const EDIT_PO_WO_LOADING = 'EDIT_PO_WO_LOADING';
export const EDIT_PO_WO_DETAIL = 'EDIT_PO_WO_DETAIL';
export const EDIT_PO_WO_LOADING_ERROR = 'EDIT_PO_WO_LOADING_ERROR';
export const EDIT_PO_WO_ITEMS_LOADING = 'EDIT_PO_WO_ITEMS_LOADING';
export const EDIT_PO_WO_ITEMS = 'EDIT_PO_WO_ITEMS';
export const RE_ORDER_PO_WO_ITEM_LIST = 'RE_ORDER_PO_WO_ITEM_LIST';
export const EDIT_PO_WO_ITEMS_LOADING_ERROR = 'EDIT_PO_WO_ITEMS_LOADING_ERROR';
export const SAVE_PO_WO_LOADING = 'SAVE_PO_WO_LOADING';
export const CLEAR_PO_WO_ERROR_SUCCESS = 'CLEAR_PO_WO_ERROR_SUCCESS';
export const SAVE_PO_WO_SUBMIT = 'SAVE_PO_WO_SUBMIT';
export const SUBMIT_PO_WO_DETAIL_ERROR = 'SUBMIT_PO_WO_DETAIL_ERROR';
export const PURCHASE_ORDER_ELE_FILE_DOWNLOAD_SUCCESS =
  'PURCHASE_ORDER_ELE_FILE_DOWNLOAD_SUCCESS';
export const DELETE_PO_WO_RECEIPT_LOADING = 'DELETE_PO_WO_RECEIPT_LOADING';
export const DELETE_PO_WO_RECEIPT_LOADING_ERROR =
  'DELETE_PO_WO_RECEIPT_LOADING_ERROR';
export const SET_TO_DATE_MIN = 'SET_TO_DATE_MIN';
export const SET_FROM_DATE_MAX = 'SET_FROM_DATE_MAX';
export const PURCHASE_ORDER_SITE_LIST = 'PURCHASE_ORDER_SITE_LIST';
export const FETCHING_SITES='FETCHING_SITES';
export const FETCH_ALL_SITE_ERROR='FETCH_ALL_SITE_ERROR';



// WEBPACK FOOTER //
// ./src/pages/inventory/managepurchaseorder/state/managePurchasseOrder/types.js